<template>
  <FormulateInput
    v-bind="{ ...$props, ...$attrs }"
    :validation-name="placeholder"
  />
</template>

<script>
export default {
  name: 'TextareaField',
  props: {
    type: {
      type: String,
      default: 'textarea',
    },
    name: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: true,
    },
    validation: {
      type: [String, Array],
      default: 'required',
    },
    rows: {
      type: Number,
      default: 5,
    },
  },
};
</script>
